import { useEffect } from 'react';

/**
 * Carga las fuentes del rediseño (Source Serif 4, Hanken Grotesk, IBM Plex Mono,
 * Material Symbols Rounded) mientras la landing está montada, y las remueve al
 * desmontar para que /app no pague el costo extra.
 */
// Fuentes de texto con display=swap (evita FOIT en el texto).
const TEXT_HREF =
  'https://fonts.googleapis.com/css2?' +
  [
    'family=Hanken+Grotesk:wght@400;500;600;700;800',
    'family=IBM+Plex+Mono:wght@400;500;600;700',
    'family=Source+Serif+4:ital,opsz,wght@0,8..60,400;0,8..60,500;0,8..60,600;0,8..60,700;1,8..60,400;1,8..60,500',
  ].join('&') +
  '&display=swap';

// Material Symbols con display=block: NUNCA muestra el nombre del icono como
// texto de fallback — se mantiene invisible hasta que la fuente carga y entonces
// pinta el glifo. (Con swap se veía "receipt_long" en crudo mientras cargaba.)
const ICON_HREF =
  'https://fonts.googleapis.com/css2?family=Material+Symbols+Rounded:opsz,wght,FILL,GRAD@24,400,0,0&display=block';

const FontPreload2 = () => {
  useEffect(() => {
    const links = [];
    const mk = (attrs, cross) => {
      const l = document.createElement('link');
      Object.assign(l, attrs);
      if (cross) l.crossOrigin = 'anonymous';
      document.head.appendChild(l);
      links.push(l);
    };
    mk({ rel: 'preconnect', href: 'https://fonts.googleapis.com' });
    mk({ rel: 'preconnect', href: 'https://fonts.gstatic.com' }, true);
    mk({ rel: 'stylesheet', href: TEXT_HREF });
    mk({ rel: 'stylesheet', href: ICON_HREF });

    return () => links.forEach((l) => l.parentNode && l.parentNode.removeChild(l));
  }, []);

  return null;
};

export default FontPreload2;
